import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "setting-event-properties"
    }}>{`Setting event properties`}</h3>
    <p>{`Optionally, you can also include additional information in the event by setting the properties value:`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      